module.exports = __webpack_public_path__ + "img/middle-east-stats.162c223c.svg";